import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminStpEditStateService } from '../../services/admin-stp-edit-state.service';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';

@Component({
  selector: 'app-admin-stp-edit-tab',
  templateUrl: './admin-stp-edit-tab.component.html',
  styleUrls: ['./admin-stp-edit-tab.component.scss'],
})
export class AdminStpEditTabComponent implements OnInit {
  selectedIndex = 0;
  userId: number | null = null;
  // edits are blocked while a renewal / re-apply is pending: its approval would copy the
  // older data back over the live STP (the backend refuses the saves as well)
  isRenewalPending = false;
  isStatusChecked = false;
  private readonly tabCount = 8;

  constructor(
    private route: ActivatedRoute,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private adminStpEditStateService: AdminStpEditStateService
  ) {}

  ngOnInit(): void {
    const userIdParam = this.route.snapshot.params.userId;
    this.userId = userIdParam ? Number(userIdParam) : null;
    if (this.userId) {
      this.loadAdminBasicProfile(this.userId);
    }
  }

  onclickButton(): void {
    this.selectedIndex = (this.selectedIndex + 1) % this.tabCount;
  }

  onclickButtonPrevious(): void {
    this.selectedIndex = this.selectedIndex - 1;
    if (this.selectedIndex < 0) {
      this.selectedIndex = this.tabCount - 1;
    }
  }

  private loadAdminBasicProfile(userId: number): void {
    this.stpRegistrationStorageService
      .readAdminBasicProfileById(userId)
      .subscribe({
        next: (res) => {
          if (!res?.data) {
            this.isStatusChecked = true;
            return;
          }

          this.adminStpEditStateService.setAdminBasicProfile(res.data);
          this.checkRenewalPending(res.data.stpMainId);
        },
        error: () => (this.isStatusChecked = true),
      });
  }

  private checkRenewalPending(stpMainId: number): void {
    if (!stpMainId) {
      this.isStatusChecked = true;
      return;
    }
    this.stpRegistrationStorageService
      .getRenewReapplyApplicationStatus(stpMainId)
      .subscribe({
        next: (res) => {
          this.isRenewalPending = !!res?.data?.hasPendingRenewOrReapplyApplication;
          this.isStatusChecked = true;
        },
        // the backend still refuses the saves if the check fails here
        error: () => (this.isStatusChecked = true),
      });
  }
}
